import React from "react";
import EntityDropDownSelector from "./entityDropDownSelector";

const EntityHeader = (props) => {
  return (
    <div className="details__header">
      <div className="details__header__partition">
        <EntityDropDownSelector entity={props.entity} entities={props.entities} path={props.path} />
      </div>
      <div className="details__header__partition">
        <div className="details__header__partition__item">
          <div className="details__header__partition__item__title">Administrator</div>
          <div className="details__header__partition__item__content">
            <div className="profile__avatar">
              <div className="profile__avatar__initials">{props.admin?.initials || "--"}</div>
            </div>
            <div className="details__header__partition__item__content__details">
              <div className="details__header__partition__item__content__details__title">
                {props.admin?.name || "--"}
              </div>
              <div
                className="details__header__partition__item__content__details__subtitle t--truncate"
                title={props.admin?.email}
              >
                {props.admin?.email || "--"}
              </div>
            </div>
          </div>
        </div>
        <div className="details__header__partition__item">
          <div className="details__header__partition__item__title">Eligibility</div>
          <a href={props.eligibility_file_url}>
            <div className="details__header__partition__item__content">
              <div className="details__header__partition__item__content__action-icon">
                <span className="material-symbols-rounded size-18">download</span>
              </div>
              <div className="details__header__partition__item__content__details">
                <div className="details__header__partition__item__content__details__title">
                  Download File
                </div>
                <div className="details__header__partition__item__content__details__subtitle">
                  340B ESP Eligibility
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="details__header__section__info__container details__header__section__info__container--mt">
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">340B ID</div>
          <div className="details__header__section__info__item__value">{props.entity.id_340b}</div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Entity Type</div>
          <div className="details__header__section__info__item__value">
            {props.entity.entity_type_code}
          </div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Primary Contact</div>
          <div className="details__header__section__info__item__value">
            {props.entity.primary_contact_name}
          </div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Authorizing Official</div>
          <div className="details__header__section__info__item__value">
            {props.entity.authorizing_official_name}
          </div>
        </div>
      </div>
      <div className="details__header__section__info__container details__header__section__info__container--bb">
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">340B ESP Registration</div>
          <div className="details__header__section__info__item__value">
            {props.entity.registered_at}
          </div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Designations</div>
          <div className="details__header__section__info__item__value">
            {props.entity.designations_count}
          </div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Contracted Pharmacies</div>
          <div className="details__header__section__info__item__value">
            {props.entity.pharmacies.length}
          </div>
        </div>
        <div className="details__header__section__info__item">
          <div className="details__header__section__info__item__title">Users</div>
          <div className="details__header__section__info__item__value">{props.user_count}</div>
        </div>
      </div>
    </div>
  );
};

export default EntityHeader;
